// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/fonts/DalaFloda-Bold-App.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/fonts/SpaceMono-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../Assets/fonts/Roboto.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../Assets/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../Assets/fonts/Montserrat-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../Assets/fonts/Montserrat-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../Assets/fonts/Montserrat-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../Assets/fonts/Montserrat-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../Assets/fonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../Assets/fonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
	font-family: dalafloda;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

@font-face {
	font-family: spacemono;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}

@font-face {
	font-family: roboto;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}

@font-face {
	font-family: montserrat;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
	font-family: montserratRegular;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}

@font-face {
	font-family: montserratMedium;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}

@font-face {
	font-family: montserratBold;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}

@font-face {
	font-family: montserratSemiBold;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('truetype');
}

@font-face {
	font-family: montserratItalics;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

@font-face {
	font-family: FontAwesome;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff2'), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('truetype');
	font-weight: normal;
	font-style: normal;
}

#root {
	width: 100%;
	@media (max-width: 768px) {
		width: 100%;
		overflow: hidden;
	}
	@media print {
		width: 100%;
		font-weight: 100;
		font-size: 9px;
		line-height: 11px;
		/*margin-left: 2em;*/
		margin-right: 2em;
	}
}

body {
	height: 100%;
	margin-left: 0;
	margin-right: 0;
	margin-top: 0;
	margin-bottom: 0;
	width: 100%;
	display: flex;
	justify-content: flex-start;
	font-family: montserrat;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/css/index.css"],"names":[],"mappings":"AAAA;CACC,sBAAsB;CACtB,+DAAsE;AACvE;;AAEA;CACC,sBAAsB;CACtB,+DAAqE;AACtE;;AAEA;CACC,mBAAmB;CACnB,+DAA0D;AAC3D;;AAEA;CACC,uBAAuB;CACvB,+DAAsE;AACvE;;AAEA;CACC,8BAA8B;CAC9B,+DAAsE;AACvE;;AAEA;CACC,6BAA6B;CAC7B,+DAAqE;AACtE;;AAEA;CACC,2BAA2B;CAC3B,+DAAmE;AACpE;;AAEA;CACC,+BAA+B;CAC/B,+DAAuE;AACxE;;AAEA;CACC,8BAA8B;CAC9B,2DAAkE;AACnE;;AAEA;CACC,wBAAwB;CACxB,wHAAgI;CAChI,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX;EACC,WAAW;EACX,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;CAClB;AACD;;AAEA;CACC,YAAY;CACZ,cAAc;CACd,eAAe;CACf,aAAa;CACb,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,2BAA2B;CAC3B,uBAAuB;AACxB","sourcesContent":["@font-face {\n\tfont-family: dalafloda;\n\tsrc: url(../../Assets/fonts/DalaFloda-Bold-App.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: spacemono;\n\tsrc: url(../../Assets/fonts/SpaceMono-Regular.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: roboto;\n\tsrc: url(../../Assets/fonts/Roboto.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserrat;\n\tsrc: url(../../Assets/fonts/Montserrat-Regular.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserratRegular;\n\tsrc: url(../../Assets/fonts/Montserrat-Regular.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserratMedium;\n\tsrc: url(../../Assets/fonts/Montserrat-Medium.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserratBold;\n\tsrc: url(../../Assets/fonts/Montserrat-Bold.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserratSemiBold;\n\tsrc: url(../../Assets/fonts/Montserrat-SemiBold.ttf) format('truetype');\n}\n\n@font-face {\n\tfont-family: montserratItalics;\n\tsrc: url(../../Assets/fonts/Montserrat-Italic.woff) format('woff');\n}\n\n@font-face {\n\tfont-family: FontAwesome;\n\tsrc: url('../../Assets/fonts/fa-solid-900.woff2') format('woff2'), url('../../Assets/fonts/fa-solid-900.ttf') format('truetype');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n\n#root {\n\twidth: 100%;\n\t@media (max-width: 768px) {\n\t\twidth: 100%;\n\t\toverflow: hidden;\n\t}\n\t@media print {\n\t\twidth: 100%;\n\t\tfont-weight: 100;\n\t\tfont-size: 9px;\n\t\tline-height: 11px;\n\t\t/*margin-left: 2em;*/\n\t\tmargin-right: 2em;\n\t}\n}\n\nbody {\n\theight: 100%;\n\tmargin-left: 0;\n\tmargin-right: 0;\n\tmargin-top: 0;\n\tmargin-bottom: 0;\n\twidth: 100%;\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tfont-family: montserrat;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
